<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="crediti-imposta-list-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.crediti-imposta.edit', params: { creditoImpostaId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'crediti-imposta-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    crediti: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'month', label: 'Mese' },
        { key: 'importo', label: 'Importo' },
      ];
    },
    tableRows () {
      return (this.crediti || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
